<template>
  <v-card>
    <dialog-bar @expand="$emit('expand', $event)"></dialog-bar>
    <v-card-text class="ma-0 pa-0">
      <v-stepper v-model="step">
        <v-stepper-header>
          <v-stepper-step :complete="step > 1" step="1">取り込み入力</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :complete="step > 2" step="2">取り込み確認</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :complete="step > 2" step="3">完了</v-stepper-step>
        </v-stepper-header>
        <v-stepper-items>
          <v-stepper-content step="1">
            <v-form style="height: 300px" ref="importForm" v-model="validImportForm" lazy-validation>
              <v-container class="pa-0">
                <v-row dense>
                  <v-col cols="12">
                    <v-file-input
                      label="CSVファイルをアップロードしてください"
                      v-model="file"
                      :rules="[rules.required, rules.isCsv]"
                    ></v-file-input>
                  </v-col>
                  <v-col cols="12">
                    <simple-file-drop v-model="file" style="height: 145px"></simple-file-drop>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
            <v-divider class="my-3"></v-divider>
            <v-btn color="secondary" @click="onComplete(false)">キャンセル</v-btn>
            <v-btn color="primary" class="float-right" @click="onImport()">取り込み</v-btn>
          </v-stepper-content>
          <v-stepper-content step="2">
            <span class="" v-if="step == 2">登録予定件数：{{ csvRecords.length }}</span>
            <div style="height: 300px">
              <ag-grid-vue
                :gridOptions="gridOptions"
                @grid-ready="onGridReady"
                :rowData="csvRecords"
                class="ag-theme-alpine"
                style="height: 100%"
                :alwaysShowHorizontalScroll="true"
              ></ag-grid-vue>
            </div>
            <v-divider class="my-3"></v-divider>
            <v-btn color="secondary" @click="onBack()">戻る</v-btn>
            <v-btn color="primary" class="float-right" @click="onSubmit()">確定</v-btn>
          </v-stepper-content>
          <v-stepper-content step="3">
            <div style="height: 300px">
              <p>{{ csvRecords.length }}件中{{ importCount }}件の取り込みが完了しました。</p>
              <p v-if="errorRows.length > 0">卸掛率の取込エラーがあります。確認してください。</p>
            </div>
            <v-divider class="my-3"></v-divider>
            <v-btn color="primary" class="float-right" @click="onComplete(true)">閉じる</v-btn></v-stepper-content
          >
        </v-stepper-items>
      </v-stepper>
    </v-card-text>
    <v-overlay :value="isLoading">
      <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
    </v-overlay>
    <error-grid-dialog
      ref="importErrorGrid"
      width="80%"
      height="80%"
      icon=""
      title="卸掛率一括取込エラー一覧"
      btnSubmit="登録"
      :columns="errorColmuns"
    ></error-grid-dialog>
  </v-card>
</template>

<style>
@import "../../../node_modules/ag-grid-community/dist/styles/ag-grid.css";
@import "../../../node_modules/ag-grid-community/dist/styles/ag-theme-alpine.css";
</style>

<script>
import { AgGridVue } from "ag-grid-vue";
import { AG_GRID_LOCALE_JA } from "../../models/ag-grid/locales";
import FileUtils from "../../utils/FileUtils";
import DialogBar from "../common/DialogBar.vue";
import SimpleFileDrop from "../common/SimpleFileDrop.vue";
import Validation from "../../libs/validation";
import { statuses as ApiStatus } from "../../libs/api-client";
import { NumericColumn, PercentColumn } from "../../models/ag-grid/columnTypes";
import ErrorGridDialog from "../../components/common/ErrorGridDialog.vue";

export default {
  name: "RateSettingImport",
  components: {
    AgGridVue,
    DialogBar,
    SimpleFileDrop,
    ErrorGridDialog,
  },
  data: () => ({
    step: 1,
    file: null,
    gridApi: null,
    columnApi: null,
    gridOptions: {
      defaultColDef: {
        resizable: true,
        sortable: false,
        filter: false,
        editable: false,
      },
      columnTypes: {
        dpNumericColumn: NumericColumn,
        dpPercentColumn: PercentColumn,
      },
      columnDefs: [
        { headerName: "仕入先法人CD", field: "supplierCorpCd" },
        { headerName: "JANCODE", field: "jancode" },
        { headerName: "掛率", field: "rate" },
      ],
      rowSelection: false,
      suppressRowClickSelection: true,
      singleClickEdit: true,
      pagination: false,
      localeText: AG_GRID_LOCALE_JA,
    },
    csvRecords: [],
    validImportForm: null,
    importFileFomat: {
      headerCnt: 1,
      details: [{ fieldName: "仕入先法人CD" }, { fieldName: "JANCODE" }, { fieldName: "掛率" }],
    },
    rules: {
      required: Validation.required,
      maxRateLength: Validation.maxRateLength,
      isRate: Validation.isRate,
      maxByteLength: Validation.maxByteLength,
      maxLength: Validation.maxLength,
      isCsv: Validation.isCsv,
    },
    importCount: 0,
    errorColmuns: [
      { headerName: "行番号", field: "rowNumber" },
      {
        headerName: "エラー内容",
        field: "errorMessage",
        wrapText: true,
        autoHeight: true,
        cellRenderer: function (param) {
          return param.data.errorMessage.join("<br>");
        },
      },
    ],
    errorRows: [],
  }),
  computed: {
    isLoading() {
      return this.$store.getters["ui/isLoading"];
    },
  },
  methods: {
    async onImport() {
      if (this.validate()) {
        let formatError = false;
        let index = 0;
        try {
          const csvLines = await FileUtils.readAsCsvSpecQuote(this.file, true);
          this.csvRecords = [];
          csvLines.splice(0, this.importFileFomat.headerCnt);
          index = this.importFileFomat.headerCnt;
          console.log(csvLines.length);
          for (const line of csvLines) {
            if (line.length == this.importFileFomat.details.length) {
              this.csvRecords.push({
                rowNumber: index,
                supplierCorpCd: line[0],
                jancode: line[1],
                rate: line[2],
              });
            } else if (csvLines.length == index && line.length == 1) {
              // 最終行の空行は無視
              console.log("line:" + line);
            } else {
              formatError = true;
              throw new Error();
            }
            index++;
          }
          if (this.validateRecords(this.csvRecords)) {
            this.step++;
          }
        } catch (error) {
          let addMessage = "";
          if (formatError) {
            addMessage = "（ファイルフォーマットエラー：" + index + "行目）";
          }
          this.$dialog.notify.error(`アップロードファイルの読み込みに失敗しました。${addMessage}`, { timeout: 2300 });
          console.log(error);
        } finally {
          await this.loadingOff();
        }
      }
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.columnApi = params.columnApi;
    },
    async validLoop(records) {
      let errors = true;
      for await (const record of records) {
        const error = await this.validateRow(record);
        if (error != true) {
          errors = false;
          this.errorRows.push({
            rowNumber: record.rowNumber,
            errorMessage: error,
          });
        }
      }
      return errors;
    },
    async onSubmit() {
      this.loadingOn();
      try {
        this.errorRows = [];
        const error = await this.validLoop(this.csvRecords);
        if (error) {
          let requestRecords = [];
          this.csvRecords.forEach(async (record) => {
            requestRecords.push(this.requestFormat(record));
          });
          this.errorRows = [];
          var param = requestRecords;
          const response = await this.$store.dispatch("rateSetting/import", param);
          let error = response.data?.header;
          switch (error.resultCode) {
            case ApiStatus.consts.SUCCESS:
              this.importCount = response.data.contents.orderRates.length;
              this.step++;
              break;
            case ApiStatus.consts.BUSINESS_ERROR:
              // エラーメッセージ格納
              if (error.messages) {
                Object.keys(error.messages).forEach((key) => {
                  this.errorRows.push({
                    rowNumber: key,
                    errorMessage: error.messages[key],
                  });
                });
              }
              if (this.errorRows.length > 0) {
                this.$refs.importErrorGrid.open({ records: this.errorRows });
              } else {
                this.$refs.importErrorGrid.close();
              }
              // 画面は完了画面に進める
              this.step++;
              break;
            default:
              this.redirectError();
              break;
          }
        } else {
          this.$refs.importErrorGrid.open({ records: this.errorRows });
          this.$dialog.notify.error(`取込データに入力エラーが存在します。ご確認ください。`, {
            timeout: 2300,
          });
        }
      } catch (error) {
        console.error("RateSettingImport::onSubmit", error);
        this.apiRequestError(error);
      } finally {
        this.loadingOff();
      }
    },
    onComplete(canceled) {
      this.$refs.importForm.resetValidation();
      this.$emit("complete", canceled);
      this.step = 1;
      this.file = null;
    },
    validate() {
      const isValid = this.$refs.importForm.validate();
      if (!isValid) {
        this.$dialog.notify.error(`入力エラーがあります`, { timeout: 2300 });
      } else {
        this.$refs.importForm.resetValidation();
      }
      return isValid;
    },
    validateRecords(records) {
      let isValid = true;
      if (records.length === 0) {
        this.$dialog.notify.error(`データがありません`, { timeout: 2300 });
        isValid = false;
      }
      return isValid;
    },
    async validateRow(row) {
      var ret = true;
      var messages = [];
      console.log("row:::::");
      console.log(row);
      // 仕入先法人CD
      this.setValidMessage(this.rules.required(row.supplierCorpCd), "仕入先法人CD", messages);
      this.setValidMessage(this.rules.maxLength(12)(row.supplierCorpCd), "仕入先法人CD", messages);
      // JANCODE
      this.setValidMessage(this.rules.maxLength(13)(row.jancode), "JANCODE", messages);
      // 掛率
      this.setValidMessage(this.rules.required(row.rate), "掛率", messages);
      this.setValidMessage(this.rules.maxLength(4)(this.percentFormat(row.rate)), "掛率", messages);
      this.setValidMessage(this.rules.isRate(this.percentFormat(row.rate, 0)), "掛率", messages);
      this.setValidMessage(this.rules.maxRateLength(3, 1)(this.percentFormat(row.rate, 0)), "掛率", messages);

      if (messages.length > 0) ret = messages;
      return ret;
    },
    requestFormat(row) {
      return {
        rowNumber: this.numberFormat(row.rowNumber),
        supplierCorpCd: this.stringFormat(row.supplierCorpCd),
        jancode: this.stringFormat(row.jancode),
        rate: this.percentFormat(row.rate),
      };
    },
    stringFormat(value) {
      if (value == null || value == "") return "";
      return String(value);
    },
    numberFormat(value) {
      if (value == null || value == "") return null;
      return Number(value);
    },
    percentFormat(value, defaultValue) {
      if (value == null || value == "") return defaultValue;
      return Number(value.replace("%", ""));
    },
    setValidMessage(check, culumnName, messages) {
      if (!(check === true)) messages.push(culumnName + "は" + check);
    },
    onBack() {
      this.$refs.importForm.resetValidation();
      this.file = null;
      this.step--;
    },
  },
};
</script>
